import { ContentMain, devices } from 'shared/styles/components';
import styled from 'styled-components';

export const BlogTitleMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondary};

  a {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  a:hover {
    color: ${({ theme }) => theme.colors.textTertiary};
    text-decoration: none;
  }
`;

export const BlogPostContent = styled(ContentMain)`
  margin-bottom: 56px;
  padding: 0 16px;

  .divider {
    margin-top: 56px;
    border-top: 2px solid ${({ theme }) => theme.colors.border};
  }

  b {
    color: ${({ theme }) => theme.colors.textEmphasis};
  }

  h2 {
    margin-top: 56px;
    color: ${({ theme }) => theme.colors.textEmphasis};
    font-family: ${({ theme }) => theme.fontFamily.display};
    letter-spacing: -1px;
  }

  h3 {
    margin-top: 40px;
    color: ${({ theme }) => theme.colors.textEmphasis};

    span.subtitle {
      color: ${({ theme }) => theme.colors.textSecondary};
      font-weight: normal;
      font-size: 16px;
    }
  }

  a {
    font-weight: bold;
  }

  p {
    margin-top: 24px !important;
    line-height: 28px !important;

    span.svg {
      display: inline-block;
      margin: 0 2px;
      height: 28px;
      vertical-align: middle;
      user-select: none;

      svg {
        height: 16px;
        fill: ${({ theme }) => theme.colors.textPrimary};

        &.theme-toggle {
          cursor: pointer;

          &:hover {
            fill: ${({ theme }) => theme.colors.textTertiary};
          }
        }
      }
    }

    img.icon {
      width: 18px;
      height: 18px;
      margin-left: 2px;
      border-radius: 0;
    }
  }

  ul {
    margin: 24px auto 0;
    max-width: 85%;

    li {
      margin-top: 8px;
      list-style: none;
    }

    @media ${devices.tabletSMax} {
      margin: 12px auto 0;
    }
  }

  table {
    margin-top: 24px;
    margin-left: auto;
    margin-right: auto;
    width: 90%;
    border-collapse: collapse;

    &.support {
      table-layout: fixed;

      td {
        text-align: left;
      }
    }

    th,
    td {
      padding: 8px;
      border: 2px solid ${({ theme }) => theme.colors.border};
      text-align: center;
    }
    th {
      font-weight: bold;
    }
  }

  blockquote {
    margin-top: 24px;
    padding: 0 16px;
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textSecondary};
    border-left: 6px solid ${({ theme }) => theme.colors.border};
  }

  figure {
    position: relative;
    margin: 56px auto;
    max-width: 66%;

    figcaption {
      color: ${({ theme }) => theme.colors.textSecondary};
      font-size: 12px;
      line-height: 16px;
      text-align: center;
    }

    @media ${devices.laptopMMax} {
      max-width: 80% !important;
    }
  }

  img {
    width: 100%;
    max-width: 100%;
    border-radius: 8px;
  }
`;
